<template>
  <div class="c-nav__list">
    <sc-link
      v-if="fields && fields.link"
      :field="fields.link"
      class="c-nav__header"
      :class="{ open: isOpen }"
      @click="openFooterLinks(fields.ref.value, $event)"
    />
    <div class="c-link-list-container" :ref="fields.ref.value">
      <div class="c-link-list">
        <sc-placeholder name="jss-footer-navlist-column-links" :rendering="rendering" />
      </div>
    </div>
  </div>
</template>

<script>
import { Link, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Footer-NavList',
  components: {
    ScLink: Link,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  data: function () {
    return {
      isOpen: false
    };
  },
  mounted() {
    this.handleView();
    window.addEventListener('resize', this.handleView);
  },
  methods: {
    handleView() {
      this.isMobileLogo = document.body.clientWidth <= 1125;

      if (document.body.clientWidth >= 992) {
        if (this.$refs[this.fields.ref.value]) {
          this.$refs[this.fields.ref.value].style.display = '';
        }
        this.isOpen = false;
      }
    },
    openFooterLinks(footerLinksSection, e) {
      if (document.body.clientWidth <= 991) {
        e.preventDefault();

        this.isOpen = !this.isOpen;
        if (this.$refs[footerLinksSection]) {
          if (
            this.$refs[footerLinksSection].style.display == '' ||
            this.$refs[footerLinksSection].style.display == 'none'
          ) {
            this.$refs[footerLinksSection].style.display = 'block';
          } else {
            this.$refs[footerLinksSection].style.display = 'none';
          }
        }
      }
    }
  }
};
</script>

<style lang="scss">
.c-footer__nav {
  .c-nav {
    &__header {
      @include font-styles('Arial Narrow', 1.8rem, 600, normal, 2.2rem, 0, $white);
      text-transform: uppercase;
      margin: 0;
      cursor: pointer;
      position: relative;
      display: block;
      text-decoration: none;

      @include desktop-up {
        margin: 0 0 -2rem 0;
      }

      &:hover {
        @include desktop-up {
          text-decoration: underline;
        }
      }

      &:after {
        content: '';
        position: absolute;
        top: 0.1rem;
        right: 0;
        display: inline-block;
        width: 1.2rem;
        height: 2rem;
        background-image: url(~@/assets/images/icon-chevron-white.svg);
        background-repeat: no-repeat;
        background-size: contain;
        transition: transform 0.2s linear;

        @include desktop-up {
          display: none;
        }
      }

      &.open {
        margin: 0 0 -2rem 0;

        &:after {
          transform: rotate(90deg);
        }
      }
    }

    &__list {
      width: 100%;
      border-bottom: 0.1rem solid rgba(255, 255, 255, 0.2);
      padding: 0 0 2.5rem 0;
      margin: 0 0 2.5rem 0;

      @include desktop-up {
        flex: 1 1 0;
        border-left: 0.1rem solid rgba(255, 255, 255, 0.2);
        padding: 0 3rem 2rem 3rem;
      }

      &:first-of-type {
        border-left: none;
        padding-left: 0;
      }

      .c-link-list-container {
        display: none;

        @include desktop-up {
          display: block;
        }
      }

      .c-link-list {
        list-style: none;
        margin: 4rem 0 0;
        padding: 0;

        &__item {
          margin: 0.8rem 0;
        }
      }
    }
  }
}
</style>
